import Modal from "/WebInterface/new-ui/modules/modal.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import {
  getSubscribeReverseNotificationEvents,
  saveSubscribeReverseNotificationEvents,
} from "/WebInterface/new-ui/assets/js/utils/api/apis.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import {
  subscribeEventTemplate,
  subscribeEventCheckBoxTemplate,
} from "./template.js";
import { fetchReverseNotificationDataAndStoreInRedux } from "/WebInterface/new-ui/modules/modals/manage-subscribed-events/manage-subscribed-events.js";
import Loader from "/WebInterface/new-ui/modules/loader/loader.js";
import { growl } from "/WebInterface/new-ui/modules/toast.js";

const subscribeEvents = [
  {
    id: "subscribe-event-downloads",
    name: "(download)",
    i18n_key: "downloads",
    label: t("downloads"),
  },
  {
    id: "subscribe-event-uploads",
    name: "(upload)",
    i18n_key: "uploads",
    label: t("uploads"),
  },
  {
    id: "subscribe-event-deletes",
    name: "(delete)",
    i18n_key: "deletes",
    label: t("deletes"),
  },
  {
    id: "subscribe-event-renames",
    name: "(rename)",
    i18n_key: "renames",
    label: t("renames"),
  },
  {
    id: "subscribe-event-create-folders",
    name: "(makedir)",
    i18n_key: "Create Folder",
    label: t("Create Folder"),
  },
];

export const initSubscribeToEvents = (item) => {
  const { href_path } = item;

  const renderSubscribeForm = async (callback) => {
    const subscribeToEventsForms = _$("#subscribeToEventsForms").empty();

    subscribeEvents.forEach((event) => {
      subscribeToEventsForms
        .el()
        .insertAdjacentHTML("beforeend", subscribeEventCheckBoxTemplate(event));
    });

    const loader = new Loader({});

    try {
      const response = await getSubscribeReverseNotificationEvents({
        method: "GET",
        path: `${href_path}/`,
      });
      if (response.commandResult?.response.toLowerCase()?.includes("error:")) {
        growl(
          utils.decodeURILocal(response.commandResult?.response),
          "",
          5000,
          true
        );
        callback(true);
        return;
      }
      const result = response?.commandResult?.response;

      subscribeEvents.forEach(({ name }) => {
        if (!result.includes(name)) {
          return;
        }

        const checkbox = _$(`#subscribeToEventsForms input[name="${name}"]`);
        checkbox.attr("checked", true);
      });
    } catch (error) {
      console.log(error);
    } finally {
      loader.deleteLoader();
    }
  };

  const submitSubscribeActionForm = async () => {
    let res = "";

    _$("#subscribeToEventsForms .subscribe-event-checkbox")
      .sel()
      .forEach((ele) => {
        if (ele?.checked) {
          res += _$(ele).attr("name");
        }
      });

    const loader = new Loader({
      parentElement: "#modal_subscribe-to-events-modal .modal-card-body",
    });

    try {
      const result = await saveSubscribeReverseNotificationEvents({
        privs: res,
        path: `${href_path}/`,
      });

      // Checking for the errors
      const response = result?.commandResult?.response;
      if (response?.toLowerCase()?.includes("error:")) {
        growl(utils.decodeURILocal(response), "", 5000, true);
        return;
      }

      await fetchReverseNotificationDataAndStoreInRedux();
      growl(
        t("subscribedEventsAreSuccessfullyUpdated"),
        t("success"),
        5000,
        false
      );
    } catch (error) {
      growl(utils.decodeURILocal(error), "", 5000, true);
    } finally {
      loader.deleteLoader();
      modal.hide(true);
    }
  };

  const modal = new Modal({
    title: "Subscribe To Events",
    body: subscribeEventTemplate({
      path: href_path,
    }),
    uniqueId: "subscribe-to-events-modal",
    onBeforeShow: () => {
      renderSubscribeForm((hasError) => {
        if (hasError) {
          modal.hide(true);
        }
      });
    },
    buttons: [
      {
        label: "cancel",
        close: true,
        classes: ["mr-3", "is-bordered"],
        onClick: () => {},
      },
      {
        label: "update",
        classes: ["mr-3"],
        onClick: () => {
          submitSubscribeActionForm();
        },
      },
    ],
  });
};
